import { useQuery } from "react-query";
import { getEmpOfficeState } from "../../../../../actions/Employees";

export const useEmployeesOfficeState = () => {
  return useQuery("GetEmpOfficeState", getEmpOfficeState, {
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });
};
